import router from "./router";
import constant from "./main.constants";
import VueI18n from "@/plugins/vue-i18n";
import Exceljs from "exceljs";
import saveAs from "file-saver";
import tableHelper from "./helpers/tableHelper";
import LZString from 'lz-string';
import DOMPurify from "dompurify";

let commonFunc = {
    prepareUniqueValueForNode(nodeType, nodeId) {
        let uniqueId = nodeId.toString()
            .replace(/ /g, "")
            .replace(/\./g, "")
            .replace(/\:/g, "")
            .replace(/\,/g, "");

        let uniqueType = nodeType.toString()
            .replace(/ /g, "")
            .replace(/\./g, "")
            .replace(/\:/g, "")
            .replace(/\,/g, "");
        return uniqueType + "_" + uniqueId;
    },
    prepareUniqueValueForLink(linkId) {
        let uniqueId = linkId.toString()
            .replace(/ /g, "")
            .replace(/\./g, "")
            .replace(/\:/g, "")
            .replace(/\,/g, "");
        return uniqueId;
    },
    formatDateTime(execTime) {
        let date = new Date(execTime);

        let day = convertTo2Chars(date.getDate());
        let month = convertTo2Chars(date.getMonth() + 1);

        let hh = convertTo2Chars(date.getHours());
        let mm = convertTo2Chars(date.getMinutes());
        let ss = convertTo2Chars(date.getSeconds());

        return day + "." + month + "." + date.getFullYear() + " " + hh + ":" + mm + ":" + ss;

        /////
        function convertTo2Chars(singleChar) {
            if (singleChar < 10) {
                singleChar = "0" + singleChar;
            }
            return singleChar;
        }
    },
    formatDate(execTime) {
        let date = new Date(execTime);
        let day = convertTo2Chars(date.getDate());
        let month = convertTo2Chars(date.getMonth() + 1);

        return day + "." + month + "." + date.getFullYear();

        /////
        function convertTo2Chars(singleChar) {
            if (singleChar < 10) {
                singleChar = "0" + singleChar;
            }
            return singleChar;
        }
    },
    dateFormat: function (dateValue) {
        let myDate;
        let dateArr = dateValue.split("-");
        if (dateArr.length > 2) {
            myDate = dateArr[2] + "." + dateArr[1] + "." + dateArr[0];
        } else {
            myDate = dateValue;
        }
        return myDate;
    },
    formatDateFibaGet(date) {
        if (date && date.length === 8) {
            const year = date.substring(0, 4);
            const month = date.substring(4, 6);
            const day = date.substring(6, 8);
            return `${day}.${month}.${year}`;
        }
    },
    formatDateFibaPost(date) {
        if (date) {
            const [day, month, year] = date.split(".");
            return `${year}${month}${day}`;
        }

    },
    timeFormat(dateValue, timeValue) {
        return dateValue + " " + timeValue + ":00";
    },
    datePickerFormat: function (dateValue) {
        let myDate;
        let dateArr = dateValue.split(".");
        myDate = dateArr[2] + "-" + dateArr[1] + "-" + dateArr[0];
        return myDate;
    },
    dateTimePickerFormat(dateAndTimeValue) {
        let myDate, myTime;
        let dateAndTime = dateAndTimeValue.split(" ");
        let dateValue = dateAndTime[0];
        let timeValue = dateAndTime[1];
        let dateArr = dateValue.split(".");
        myDate = dateArr[2] + "-" + dateArr[1] + "-" + dateArr[0];
        myTime = timeValue ? timeValue.substring(0, 5) : "00:00";
        return { date: myDate, time: myTime };
    },
    dateFormatToYYYYMMDD(dateValue) {
        const onlyDate = dateValue.split("T")[0];

        return onlyDate;
    },
    dbDateToTrDate(dateValue) {
        if (dateValue) {
            const dateAndTime = dateValue.split("T");
            if (dateAndTime.length > 1) {
                const dateParts = dateAndTime[0].split('-');
                if (dateParts.length > 2) {
                    const timeParts = dateAndTime[1].split(".");
                    if (timeParts.length > 1) {
                        return dateParts[2] + "." + dateParts[1] + "." + dateParts[0] + " " + timeParts[0];
                    } else {
                        return dateParts[2] + "." + dateParts[1] + "." + dateParts[0] + " " + dateAndTime[1];
                    }
                } else {
                    return "";
                }
            } else {
                return "";
            }
        } else {
            return "";
        }

    },
    dbDateToTrDateWithoutTime(dateValue) {
        if (dateValue) {
            let dateAndTime = dateValue.split("T");
            if (dateAndTime.length > 1) {
                let dateParts = dateAndTime[0].split('-');
                if (dateParts.length > 2) {
                    let trDateAndTime = dateParts[2] + "." + dateParts[1] + "." + dateParts[0];
                    return trDateAndTime;
                } else {
                    return "";
                }
            } else {
                return "";
            }
        } else {
            return "";
        }
    },
    dateToTrDateWithoutTime(dateValue) {
        if (dateValue) {
            const dateParts = dateValue.split("-");
            if (dateParts.length > 2) {
                return `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
            } else {
                return "";
            }
        } else {
            return "";
        }
    },
    replaceAllWithoutReplaceAll(item, from, to) {
        let lastWord = '';
        let index = 0;
        let fromCurrentIndex = 0;
        let convertedWord = '';
        while (index < item.length) {
            if (item[index] == from[fromCurrentIndex]) {
                lastWord += from[fromCurrentIndex];
                if (lastWord == from) {
                    convertedWord += to;
                    lastWord = '';
                    fromCurrentIndex = 0;
                }
                else {
                    fromCurrentIndex++;
                }
            } else {
                convertedWord += lastWord;
                convertedWord += item[index];
                lastWord = '';
                fromCurrentIndex = 0;
            }
            index++;
        }

        if (lastWord != '') {
            convertedWord += lastWord;
        }

        return convertedWord;
    },
    groupBy(input, key) {
        return input.reduce((acc, currentValue) => {
            const groupKey = currentValue[key];
            if (!acc[groupKey]) {
                acc[groupKey] = [];
            }
            acc[groupKey].push(currentValue);
            return acc;
        }, {});
    },
    getRandomColor() {
        let letters = "0123456789ABCDEF";
        let color = "#";
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    },
    sortEntities(entitiesWithAttributes) {
        entitiesWithAttributes.sort(function (a, b) {
            if (a.entityOrder && b.entityOrder) {
                return a.entityOrder - b.entityOrder;
            } else if (a.entityOrder) {
                return -1;
            } else if (b.entityOrder) {
                return 1;
            } else {
                return 0;
            }
        });
        return entitiesWithAttributes;
    },
    pastedOnTextArea(e, attr, myThis) {
        e.preventDefault();
        attr.operator = "in";
        attr.value = "";
        attr.similarityPercentage = undefined;
        attr.isOperatorSimilar = false;
        let newText = "";
        let activeEl = document.activeElement;
        let textStart = activeEl.value.slice(0, activeEl.selectionStart);
        let textEnd = activeEl.value.slice(activeEl.selectionEnd, activeEl.value.length);

        let pastedArr = e.clipboardData.getData("text/plain").split("\n");
        pastedArr.forEach((arr, i) => {
            if (arr != "") {
                if (arr[arr.length - 1] == "\r") {
                    newText += arr.substring(0, arr.length - 1);
                } else if (arr[0] == "\r") {
                    newText += arr.substring(1, arr.length);
                } else {
                    newText += arr.substring(0, arr.length);
                }

                if (i != pastedArr.length - 1) newText += ",";
            }
        });
        if (newText[0] == ",") {
            newText = newText.substring(1, newText.length);
        }
        if (newText[newText.length - 1] == ",") {
            newText = newText.substring(0, newText.length - 1);
        }

        if (textStart[textStart.length - 1] == "," && textStart != "") {
            textStart = textStart.substring(0, textStart.length - 1);
        }
        if (textStart == "" && textEnd == "") {
            attr.value = newText;
        } else {
            if (textStart != "") {
                attr.value += textStart + "," + newText + textEnd;
            } else {
                attr.value += newText + textEnd;
            }
        }

        if (myThis.singleQueryMode) {
            if (myThis.singleQueryMode == 2) {
                myThis.nodeEdgeMapWithAttrs = JSON.parse(JSON.stringify(myThis.nodeEdgeMapWithAttrs));
            } else {
                myThis.selectedEntityAttrs = JSON.parse(JSON.stringify(myThis.selectedEntityAttrs));
            }
        }
    },
    //TODO ktolga: coğrafi analiz içerisinden de bu fonksiyon çağırılmalı
    operatorChange(attr, myThis) {
        if (attr.operator == "between") {
            if (attr.timeValue == null && attr.dataType == "Datetime") {
                attr.timeValue = "00:00";
            }
            attr.isBetween = true;
            attr.isLastDate = false;
            if (attr.dataType == "Datetime") {
                attr.timeValueBetween = "23:59";
            }
            attr.textDisabled = false;
            attr.isOperatorSimilar = false;
            attr.similarityPercentage = undefined;
        } else if (attr.operator == "is null" || attr.operator == "is not null" || attr.operator == "previous week" || attr.operator == "previous month") {
            attr.textDisabled = true;
            attr.isLastDate = false;
            attr.isBetween = false;
            attr.value = undefined;
            attr.valueMax = undefined;
            attr.isOperatorSimilar = false;
            attr.similarityPercentage = undefined;
        } else if (
            attr.operator == "last day" ||
            attr.operator == "last month" ||
            attr.operator == "last year" ||
            attr.operator == "last hour" ||
            attr.operator == "last minute"
        ) {
            attr.textDisabled = false;
            attr.isBetween = false;
            attr.value = undefined;
            attr.valueMax = undefined;
            attr.isLastDate = true;
            attr.isOperatorSimilar = false;
            attr.similarityPercentage = undefined;
        } else if (attr.operator == "similar") {
            attr.isOperatorSimilar = true;
            attr.isBetween = false;
            attr.valueMax = undefined;
            attr.isLastDate = false;
            attr.textDisabled = false;
        } else {
            if (attr.timeValue == null && attr.dataType == "Datetime") {
                attr.timeValue = "00:00";
            }
            attr.isBetween = false;
            attr.valueMax = undefined;
            attr.isLastDate = false;
            attr.textDisabled = false;
            attr.isOperatorSimilar = false;
            attr.similarityPercentage = undefined;
        }

        if (myThis.singleQueryMode == 2) {
            myThis.nodeEdgeMapWithAttrs = JSON.parse(JSON.stringify(myThis.nodeEdgeMapWithAttrs));
        } else {
            myThis.selectedEntityAttrs = JSON.parse(JSON.stringify(myThis.selectedEntityAttrs));
        }
    },
    prepareSingleQueryFilters(entityAttrs, filters, myThis) {
        let commonFuncThis = this;

        entityAttrs.forEach((filter) => {
            let filterValue, filterMaxValue, parameterDatatype = null;
            if ((filter.value != undefined && filter.value != null && filter.value != "") || filter.textDisabled) {
                if (!filter.textDisabled) {
                    if (filter.dataType == "Date") {
                        if (!filter.isLastDate) {
                            filterValue = commonFuncThis.dateFormat(filter.value);

                            if (filter.operator == "between") {
                                if (filter.valueMax) {
                                    filterMaxValue = commonFuncThis.dateFormat(filter.valueMax);
                                }
                            }
                        } else {
                            filterValue = filter.value;
                        }
                    } else if (filter.dataType == "Datetime") {
                        if (!filter.isLastDate) {
                            filterValue = commonFuncThis.dateTimeFormat(filter.value, filter.timeValue);

                            if (filter.operator == "between") {
                                if (filter.valueMax) {
                                    filterMaxValue = this.dateTimeFormat(filter.valueMax, filter.timeValueBetween);
                                }
                            }
                        } else {
                            filterValue = filter.value;
                        }
                    } else if (filter.dataType == "Parameter") {
                        parameterDatatype = commonFuncThis.addParameterDatatypeToFilter(myThis, filter);
                        filterValue = filter.value.join("#!#");
                    }
                    else if (filter.name == 'sanctionorpepinput') {
                        filterValue = commonFuncThis.getPepAndSanctionMapValue(filter.value);
                    }
                    else {
                        filterValue = filter.value;

                        if (filter.operator == "between") {
                            filterMaxValue = filter.valueMax;
                        }
                    }
                } else {
                    filterValue = "";
                }

                if (filter.textDisabled) {
                    filters[filter.name] = [];
                    filters[filter.name].push({
                        Operator: filter.operator,
                        Type: filter.dataType
                    });
                } else {
                    let checkValue = filterValue.replace(/ /g, "");
                    if (checkValue != "") {
                        filters[filter.name] = [];

                        filters[filter.name].push({
                            FilterType:
                                filter.dataType == "Parameter" ? constant.FILTER_TYPES.parameter : constant.FILTER_TYPES.static,
                            Value: filterValue,
                            ValueMax: filterMaxValue,
                            Operator: filter.operator,
                            Type: filter.dataType,
                            CaseSensitive: filter.caseSensitive,
                            LanguageSensitive: filter.languageSensitive,
                            ParameterDatatype: parameterDatatype,
                            SimilarityPercentage: filter.similarityPercentage
                        });
                    }
                }
                if (myThis.complexQueryFilters) {
                    if (!myThis.complexQueryFilters[filter.name]) {
                        myThis.complexQueryFilters[filter.name] = [];
                    }
                    let isFilterDuplicated = false;
                    myThis.complexQueryFilters[filter.name].forEach((filterControl) => {
                        if (filterControl.Value == filterValue) {
                            isFilterDuplicated = true;
                        }
                    });
                    if (!isFilterDuplicated) {
                        myThis.complexQueryFilters[filter.name].push({
                            FilterType:
                                filter.dataType == "Parameter" ? constant.FILTER_TYPES.parameter : constant.FILTER_TYPES.static,
                            Value: filterValue,
                            ValueMax: filterMaxValue,
                            Operator: filter.operator,
                            Type: filter.dataType,
                            CaseSensitive: filter.caseSensitive,
                            LanguageSensitive: filter.languageSensitive,
                            ParameterDatatype: parameterDatatype,
                            SimilarityPercentage: filter.similarityPercentage
                        });
                    }
                }

            }
        });
    },
    addParameterDatatypeToFilter(myThis, filter) {
        let parameterSourceAttrDatatype = myThis.entitiesWithAttributes
            .find((entity) => {
                return entity.id == filter.fillentityid;
            })
            .attributeList.find((attr) => {
                return attr.entityAttributeId == filter.valueentityattributeid;
            })?.datatype;
        return parameterSourceAttrDatatype;
    },
    dateFormat: function (dateValue) {
        let myDate;
        let dateArr = dateValue.split("-");
        if (dateArr.length > 2) {
            myDate = dateArr[2] + "." + dateArr[1] + "." + dateArr[0];
        } else {
            myDate = dateValue;
        }
        return myDate;
    },
    dateTimeFormat(dateValue, timeValue) {
        let myDate = this.dateFormat(dateValue);
        let HHmm = timeValue ? timeValue : "00:00"

        return myDate + " " + HHmm + ":00";
    },
    logOut(isTokenExpired) {
        let localStorageItems = constant.LOCAL_STORAGE_ITEMS;
        let sessionStorageItems = constant.SESSION_STORAGE_ITEMS;

        Object.keys(localStorageItems).forEach(item => {
            if (!constant.DONT_REMOVE_LOCALE_STORAGE_ITEMS[item]) {
                localStorage.removeItem(localStorageItems[item]);
            }
        });

        Object.keys(sessionStorageItems).forEach(item => {
            sessionStorage.removeItem(sessionStorageItems[item]);
        });

        //TODO: cookieye göre işlem yapılırsa bu satır açılmalı
        //this.deleteCookies();

        // Hard refresh ile login sayfasina yönlendirr (logout ya da expire oluncamemory release olmuyordu)
        if (router.history.current.path != "/login") {
            const loginHash = isTokenExpired
                ? "#/login?type=tokenExpired"
                : "#/login";
            window.location.hash = loginHash;
            window.location.reload();
        }
    },
    getCookieValue(name) {
        return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';
    },
    deleteCookies() {
        document.cookie.split(';').forEach(function (c) {
            document.cookie = c.trim().split('=')[0] + '=;' + 'expires=Thu, 01 Jan 1970 00:00:00 UTC;';
        });
    },
    checkEntityPermissionWithName(entityName) {
        if (localStorage.entityNameEntityIdMap) {
            let permList = localStorage.perms.split(';');
            let entityId = JSON.parse(localStorage.entityNameEntityIdMap)[entityName];
            return permList.indexOf("perm_entity_" + entityId) > -1;
        } else {
            this.errorHandler("metaDataLoadError");
        }
    },
    checkPermissionWithName(permName) {
        if (localStorage.perms) {
            let permList = localStorage.perms.split(';');
            return permList.indexOf(permName) > -1;
        }
        return false;
    },
    // EXAMPLE
    // en =>  "yearsOld": "I'm {0} years old, I live in {1}",
    // tr => "yearsOld": "{0} yaşındayım, {1}da yaşıyorum",
    // call => languageLocalize("yearsOld", 21, "İstanbul")
    localize(localizeKey, ...args) {
        let translatedWord = "";
        if (VueI18n.te("KEYS." + localizeKey)) {
            translatedWord = VueI18n.t("KEYS." + localizeKey);
        } else {
            return localizeKey;
        }
        const parameters = [];
        args.forEach((arg) => {
            if (arg) {
                if (VueI18n.te("KEYS." + arg)) {
                    const translatedArg = VueI18n.t("KEYS." + arg);
                    parameters.push(translatedArg);
                } else {
                    parameters.push(arg);
                }
            }
        });

        return commonFunc.formatString(translatedWord, ...parameters);
    },
    localizeAlert(localizeKey, ...args) {
        const translatedWord = VueI18n.t("ALERTS." + localizeKey);
        if (translatedWord.startsWith("ALERTS.")) {
            return localizeKey;
        }
        return commonFunc.formatString(translatedWord, ...args);
    },
    formatString(sentence, ...args) {
        let formattedSentence = sentence;
        for (let i = 0; i < args.length; i++) {
            formattedSentence = formattedSentence.replaceAll(
                `{${i}}`,
                args[i]
            );
        }
        return formattedSentence;
    },
    // Encoding UTF8 ⇢ base64
    base64EncodeUnicode(str) {
        return btoa(
            encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) =>
                String.fromCharCode(parseInt(p1, 16))
            )
        );
    },
    // Decoding base64 ⇢ UTF8
    base64DecodeUnicode(str) {
        return decodeURIComponent(
            Array.prototype.map
                .call(
                    atob(str),
                    (c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
                )
                .join('')
        );
    },
    decodeBase64ToUTF8(token) {
        const tokenPayload = token.split(".")[1];
        const decodedPayload = decodeURIComponent(escape(atob(tokenPayload)));;
        const tokenInfoMap = JSON.parse(decodedPayload);
        return tokenInfoMap;
    },
    deepCopy(element) {
        if (element) {
            return JSON.parse(JSON.stringify(element));
        } else {
            return element;
        }
    },
    checkListAndJoin(array, delimeter) {
        if (!delimeter) {
            delimeter = ",";
        }
        return array && array.length > 0 ? array.join(delimeter) : "";
    },
    fetchIcon(icontype) {
        let serverAddress = window.location.origin;

        if (constant.serverAddress && constant.serverAddress != "/") {
            serverAddress = constant.serverAddress;
        }

        if (icontype) {
            return `${serverAddress}${constant.staticFileUri}${icontype}`;
        } else {
            return `${serverAddress}${constant.nullIconValue}`;
        }

    },
    findEntityIdByName(entityName) {
        if (localStorage.entitiesWithAttributes) {
            const entitiesWithAttributes = this.getCompressedItem('entitiesWithAttributes');
            const foundEntity = entitiesWithAttributes.find(item => item.name == entityName);
            if (foundEntity) {
                return foundEntity.id;
            }
            return -1
        } else {
            this.errorHandler("metaDataLoadError");
        }
    },
    numberToTextTr(number) {
        const ones = ["", "bir", "iki", "üç", "dört", "beş", "altı", "yedi", "sekiz", "dokuz"];
        const tens = ["", "on", "yirmi", "otuz", "kırk", "elli", "atmış", "yetmiş", "seksen", "doksan"];
        const hundreds = ["", "yüz", "iki yüz", "üç yüz", "dört yüz", "beş yüz", "altı yüz", "yedi yüz", "sekiz yüz", "dokuz yüz"];

        if (number === 0) {
            return 'sıfır';
        }

        let text = '';

        if (number >= 100) {
            const hundredStep = Math.floor(number / 100);
            text += hundreds[hundredStep] + ' ';
            number %= 100;
        }

        if (number >= 10) {
            const tenStep = Math.floor(number / 10);
            text += tens[tenStep];
            number %= 10;

            if (number > 0) {
                text += ' ' + ones[number];
            }
        } else if (number > 0) {
            text += ones[number];
        }

        return text;

    },
    copyText(text, textAreaId) {
        if (window.isSecureContext && navigator.clipboard) {
            navigator.clipboard
                .writeText(text)
        } else {
            this.unsecuredCopyToClipboard(text, textAreaId);
        }
    },
    unsecuredCopyToClipboard(text, textAreaId) {
        const textAreaElement = document.getElementById(textAreaId);
        textAreaElement.value = text;
        textAreaElement.focus();
        textAreaElement.select();
        document.execCommand("copy");

    },
    excelExport(data, worksheet, fileName, headerList, isShowTotalValue) {
        const filteredHeaderList = headerList.filter(item => item.datatype !== undefined);
        const extension = ".xlsx";

        if (!fileName.includes(extension)) {
            fileName = `${fileName}${extension}`;
        }

        const headers = filteredHeaderList.map(({ value }) => value);
        const dataRows = data.map((item) =>
            headers.map((header) => item[header])
        );
        const workbook = new Exceljs.Workbook();
        const sheet = workbook.addWorksheet(`${worksheet}`);
        const imageColumns = [];
        filteredHeaderList.forEach((header, index) => {
            if (header.datatype === constant.ATTR_DATA_TYPES.Image) {
                imageColumns.push(index);
            }
        });
        const imageData = [];
        dataRows.forEach((row, rowIndex) => {
            imageColumns.forEach(colIndex => {
                if (row[colIndex]) {
                    imageData.push({
                        rowIndex: rowIndex + 2, // +2 çünkü header var ve Excel 1'den başlar
                        colIndex: colIndex,
                        base64: row[colIndex]
                    });
                    row[colIndex] = ''; // Hücreyi boşalt
                }
            });
        });
        filteredHeaderList.forEach((header, index) => {
            if (header.datatype == constant.ATTR_DATA_TYPES.Currency) {
                dataRows.forEach((row) => {
                    if (row[index]) {
                        const rowIndexValue = row[index].toString();
                        if (rowIndexValue.includes(",")) {
                            const tempValue = parseFloat(rowIndexValue.replace(",", "."));
                            if (tempValue != NaN) {
                                row[index] = tempValue;
                            }
                        } else {
                            row[index] = parseFloat(rowIndexValue);
                        }
                    }
                })
            } else if (header.datatype == constant.ATTR_DATA_TYPES.Numeric) {
                dataRows.forEach((row) => {
                    if (row[index] != null) {
                        row[index] = parseFloat(row[index]);
                    }
                })
            }
        })

        sheet.addTable({
            name: "Table",
            ref: "A1",
            headerColumns: true,
            style: {
                theme: "TableStyleLight1", // isteğe bağlı değiştirilebilir.  https://learn.microsoft.com/en-us/javascript/api/excel/excel.table?view=excel-js-preview
                showRowStripes: constant.SHOW_EXCEL_ROW_STRIPES
            },
            columns: filteredHeaderList.map((header) => ({ name: header.text })),
            rows: dataRows,
        });

        filteredHeaderList.forEach((column, columnIndex) => { //Hücreler genişlik ayarı.. başlık vs data
            let maxCellWidth = column.text.length;
            sheet.eachRow({ includeEmpty: true }, (row, rowIndex) => {
                if (rowIndex > 1) {
                    const cell = row.getCell(columnIndex + 1);
                    const cellValue = cell.value;
                    if (cellValue) {
                        const cellWidth = cellValue.toString().length;
                        if (cellWidth > maxCellWidth) {
                            maxCellWidth = cellWidth;
                        }
                    }
                }
            });
            if (imageColumns.includes(columnIndex)) {
                sheet.columns[columnIndex].width = 15;
                sheet.getRow(1).height = 20;
                for (let i = 2; i <= dataRows.length + 1; i++) {
                    sheet.getRow(i).height = 120;
                }
            } else {
                sheet.columns[columnIndex].width = Math.min(maxCellWidth + 3, 50);
            }
            if (filteredHeaderList[columnIndex] && filteredHeaderList[columnIndex].datatype && filteredHeaderList[columnIndex].datatype === constant.ATTR_DATA_TYPES.Currency && isShowTotalValue) {
                const total = this.sumCurrencyData(filteredHeaderList[columnIndex], data, true);
                const lastRowIndex = sheet.columns[columnIndex].values.length;
                sheet.getCell(lastRowIndex, columnIndex + 1).value = total.includes(",") ? parseFloat(total.replace(",", ".")) : parseFloat(total);
            }
            sheet.getColumn(sheet.columns[columnIndex].letter).alignment = { horizontal: 'left' };

            if (filteredHeaderList[columnIndex] && filteredHeaderList[columnIndex].datatype && filteredHeaderList[columnIndex].datatype == constant.ATTR_DATA_TYPES.Datetime
            ) {
                sheet.getColumn(sheet.columns[columnIndex].letter).numFmt = 'dd.mm.yyyy hh:mm:ss';
            } else if (filteredHeaderList[columnIndex] && filteredHeaderList[columnIndex].datatype && filteredHeaderList[columnIndex].datatype == constant.ATTR_DATA_TYPES.Date) {
                sheet.getColumn(sheet.columns[columnIndex].letter).numFmt = 'dd.mm.yyyy';
            } else if (filteredHeaderList[columnIndex] && filteredHeaderList[columnIndex].datatype && filteredHeaderList[columnIndex].datatype == constant.ATTR_DATA_TYPES.Currency) {
                sheet.getColumn(sheet.columns[columnIndex].letter).numFmt = '###,###.00'; //excel formatlaması bu şekilde excel indirilince 1.234.567,00 şeklinde gözüküyor
            } else if (filteredHeaderList[columnIndex] && filteredHeaderList[columnIndex].datatype && filteredHeaderList[columnIndex].datatype === constant.ATTR_DATA_TYPES.Numeric) {
                const columnLetter = sheet.columns[columnIndex].letter;
                for (let i = 2; i <= sheet.rowCount; i++) {
                    const cell = sheet.getCell(`${columnLetter}${i}`);
                    cell.alignment = { horizontal: 'right' };
                }
            }
        });
        imageData.forEach((img) => {
            try {
                let base64Data = img.base64;
                if (base64Data.startsWith('data:image')) {
                    base64Data = base64Data.split(',')[1];
                }
                const imageId = workbook.addImage({
                    base64: base64Data,
                    extension: 'jpeg',
                });
                const columnLetter = sheet.getColumn(img.colIndex + 1).letter;
                sheet.addImage(imageId, {
                    tl: { col: img.colIndex + 0.1, row: img.rowIndex - 1 + 0.1 },
                    ext: { width: 100, height: 75 }
                });
            } catch (error) {
                console.error('Error while inserting image:', error);
            }
        });
        workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: "application/octet-stream" }), `${fileName}`);
        });
    },
    excelExportMultiSheet(sheetsData, fileName, isShowTotalValue) {
        const workbook = new Exceljs.Workbook();

        sheetsData.forEach((sheetInfo) => {
            const filteredHeaderList = sheetInfo.headers.filter((item) => item.datatype !== undefined);
            if (filteredHeaderList.length === 0) {
                return;
            }
            const headers = filteredHeaderList.map(({ value }) => value);
            const dataRows = sheetInfo.items.map((item) =>
                headers.map((header) => item[header])
            );
            const sheetName = (sheetInfo.sheetName || "Sheet").substring(0, 31);
            const sheet = workbook.addWorksheet(sheetName);

            const imageColumns = [];
            filteredHeaderList.forEach((header, index) => {
                if (header.datatype === constant.ATTR_DATA_TYPES.Image) {
                    imageColumns.push(index);
                }
            });

            const imageData = [];
            if (imageColumns.length > 0) {
                dataRows.forEach((row, rowIndex) => {
                    imageColumns.forEach((colIndex) => {
                        if (row[colIndex]) {
                            imageData.push({
                                rowIndex: rowIndex + 2,
                                colIndex: colIndex,
                                base64: row[colIndex]
                            });
                            row[colIndex] = "";
                        }
                    });
                });
            }

            filteredHeaderList.forEach((header, index) => {
                if (header.datatype == constant.ATTR_DATA_TYPES.Currency) {
                    dataRows.forEach((row) => {
                        if (row[index]) {
                            const rowIndexValue = row[index].toString();
                            if (rowIndexValue.includes(",")) {
                                const tempValue = parseFloat(rowIndexValue.replace(",", "."));
                                if (tempValue != NaN) {
                                    row[index] = tempValue;
                                }
                            } else {
                                row[index] = parseFloat(rowIndexValue);
                            }
                        }
                    });
                } else if (header.datatype == constant.ATTR_DATA_TYPES.Numeric) {
                    dataRows.forEach((row) => {
                        if (row[index] != null) {
                            row[index] = parseFloat(row[index]);
                        }
                    });
                }
            });

            const tableName = `Table_${sheetInfo.sheetName || "Sheet"}`.replace(/[^a-zA-Z0-9_]/g, "_").substring(0, 50);
            sheet.addTable({
                name: tableName,
                ref: "A1",
                headerColumns: true,
                style: {
                    theme: "TableStyleLight1",
                    showRowStripes: constant.SHOW_EXCEL_ROW_STRIPES
                },
                columns: filteredHeaderList.map((header) => ({ name: header.text })),
                rows: dataRows
            });

            filteredHeaderList.forEach((column, columnIndex) => {
                let maxCellWidth = column.text.length;
                sheet.eachRow({ includeEmpty: true }, (row, rowIndex) => {
                    if (rowIndex > 1) {
                        const cell = row.getCell(columnIndex + 1);
                        const cellValue = cell.value;
                        if (cellValue) {
                            const cellWidth = cellValue.toString().length;
                            if (cellWidth > maxCellWidth) {
                                maxCellWidth = cellWidth;
                            }
                        }
                    }
                });

                if (imageColumns.includes(columnIndex)) {
                    sheet.columns[columnIndex].width = 15;
                    sheet.getRow(1).height = 20;
                    for (let i = 2; i <= dataRows.length + 1; i++) {
                        sheet.getRow(i).height = 120;
                    }
                } else {
                    sheet.columns[columnIndex].width = Math.min(maxCellWidth + 3, 50);
                }

                if (filteredHeaderList[columnIndex] && filteredHeaderList[columnIndex].datatype === constant.ATTR_DATA_TYPES.Currency && isShowTotalValue) {
                    const total = this.sumCurrencyData(filteredHeaderList[columnIndex], sheetInfo.items, true);
                    const lastRowIndex = sheet.columns[columnIndex].values.length;
                    sheet.getCell(lastRowIndex, columnIndex + 1).value = total.includes(",") ? parseFloat(total.replace(",", ".")) : parseFloat(total);
                }

                sheet.getColumn(sheet.columns[columnIndex].letter).alignment = { horizontal: "left" };

                if (filteredHeaderList[columnIndex] && filteredHeaderList[columnIndex].datatype == constant.ATTR_DATA_TYPES.Datetime) {
                    sheet.getColumn(sheet.columns[columnIndex].letter).numFmt = "dd.mm.yyyy hh:mm:ss";
                } else if (filteredHeaderList[columnIndex] && filteredHeaderList[columnIndex].datatype == constant.ATTR_DATA_TYPES.Date) {
                    sheet.getColumn(sheet.columns[columnIndex].letter).numFmt = "dd.mm.yyyy";
                } else if (filteredHeaderList[columnIndex] && filteredHeaderList[columnIndex].datatype == constant.ATTR_DATA_TYPES.Currency) {
                    sheet.getColumn(sheet.columns[columnIndex].letter).numFmt = "###,###.00";
                } else if (filteredHeaderList[columnIndex] && filteredHeaderList[columnIndex].datatype === constant.ATTR_DATA_TYPES.Numeric) {
                    const columnLetter = sheet.columns[columnIndex].letter;
                    for (let i = 2; i <= sheet.rowCount; i++) {
                        const cell = sheet.getCell(`${columnLetter}${i}`);
                        cell.alignment = { horizontal: "right" };
                    }
                }
            });

            imageData.forEach((img) => {
                try {
                    let base64Data = img.base64;
                    if (base64Data.startsWith("data:image")) {
                        base64Data = base64Data.split(",")[1];
                    }
                    const imageId = workbook.addImage({
                        base64: base64Data,
                        extension: "jpeg"
                    });
                    sheet.addImage(imageId, {
                        tl: { col: img.colIndex + 0.1, row: img.rowIndex - 1 + 0.1 },
                        ext: { width: 100, height: 75 }
                    });
                } catch (error) {
                  console.error("Error : ", error);
                }
            });
        });

        workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: "application/octet-stream" }), fileName);
        });
    },
    currencyFormatter(data) {
        return parseFloat(data.toString().replace(",", ".")).toLocaleString(
            constant.CURRENCY_LOCALE_INFO[VueI18n.locale].currencyTitle,
            {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
                currency: constant.CURRENCY_LOCALE_INFO[VueI18n.locale].currencyType,
            }
        );
    },
    sumCurrencyData(element, items, isForExcel = false) {
        const calculatedItem = items
            .reduce((a, b) => {
                let value;
                if (b && b[element.value]) {
                    value = parseFloat(b[element.value].toString().replace(",", "."));
                } else {
                    value = 0;
                }
                return a + (value || 0);
            }, 0)
            .toString();
        if (isForExcel) {
            return calculatedItem;
        }
        return tableHelper.createTableContents(calculatedItem, element, 20);
    },
    normalizeSearchValue(value, search, item) {
        const normalizedSearch = search ? this.normalizeTurkish(search) : "";
        const normalizedValue = value ? this.normalizeTurkish(value) : "";
        return normalizedValue.includes(normalizedSearch);
    },
    normalizeString(str) {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
    normalizeTurkish(text) {
        if (!text) return "";
        return text
            .toString()
            .replace(/İ/g, "i")
            .replace(/Ş/g, "s")
            .replace(/Ğ/g, "g")
            .replace(/Ü/g, "u")
            .replace(/Ö/g, "o")
            .replace(/Ç/g, "c")
            .replace(/ş/g, "s")
            .replace(/ğ/g, "g")
            .replace(/ü/g, "u")
            .replace(/ö/g, "o")
            .replace(/ç/g, "c")
            .toLowerCase();
    },
    getParameterStringValue(item, col, saveAsStringMap, parameterEntityMaps, entitiesWithAttributes) {
        if (saveAsStringMap && parameterEntityMaps && entitiesWithAttributes) {
            const columnNameParsed = col.columnName.split("_");
            if (entitiesWithAttributes && columnNameParsed && columnNameParsed.length == 3) {
                const entity = entitiesWithAttributes.find((t) => t.id == columnNameParsed[1]);
                const attr = entity.attributeList.find((t) => t.id == columnNameParsed[2]);
                if (saveAsStringMap[entity.name] && saveAsStringMap[entity.name][attr.name]) {
                    const parameterMap = parameterEntityMaps[saveAsStringMap[entity.name][attr.name].fillEntityId];
                    if (parameterMap) {
                        const found = parameterMap.find(
                            (t) => t[saveAsStringMap[entity.name][attr.name].valueEntityAttributeName] == item[col.value]
                        );
                        if (found) {
                            return found[saveAsStringMap[entity.name][attr.name].textEntityAttributeName] ?? item[col.value];
                        }
                    }
                }
            }
            return item[col.value];
        }
        return item[col.value];
    },
    getCurrentDateAndTime() {
        const now = new Date();
        const formattedDate = now.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '');
        const formattedTime = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }).replace(/:/g, '');
        return `${formattedDate}_${formattedTime}`;
    },
    getCurrentDate() {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, "0");
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const year = today.getFullYear();
        return `${day}.${month}.${year}`;
    },
    pastedOnTextField(e, newText) {
        const pastedArr = e.clipboardData.getData("text/plain").split("\n");
        const lastChar = newText.slice(-1);
        if (newText && lastChar != ",") {
            newText += ","
        }
        pastedArr.forEach((arr, i) => {
            if (arr != "") {
                if (arr[arr.length - 1] == "\r") {
                    newText += arr.substring(0, arr.length - 1);
                } else if (arr[0] == "\r") {
                    newText += arr.substring(1, arr.length);
                } else {
                    newText += arr.substring(0, arr.length);
                }
                if (i != pastedArr.length - 1) newText += ",";
            }
        });
        e.preventDefault();
        return newText;
    },
    setInfoCardTheme(infoCard) {
        let selectedTheme = "";
        let isBlackText = null;
        if (infoCard.selectedTheme && infoCard.selectedTheme.includes(",")) {
            const theme = infoCard.selectedTheme.split(",");
            selectedTheme = theme[0];
            isBlackText = theme[1] == "true";
        } else {
            selectedTheme = infoCard.selectedTheme;
        }
        const theme = {
            selectedTheme: selectedTheme,
            isBlackText: isBlackText
        }
        return theme;
    },
    clearSessionStorage() {
        sessionStorage.removeItem("analysisId");
        sessionStorage.removeItem("analysisQueryId");
        sessionStorage.removeItem("analysisReason");
    },
    setCompressedItem(key, value) {
        try {
            const jsonString = typeof value === 'string' ? value : JSON.stringify(value);
            const compressed = LZString.compressToBase64(jsonString);
            localStorage.setItem(key, compressed);
        } catch (error) {
            console.error('Compression error for key:', key, error);
            localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
        }
    },
    getCompressedItem(key) {
        try {
            const compressed = localStorage.getItem(key);
            if (!compressed) {
                return null;
            }
            const decompressed = LZString.decompressFromBase64(compressed);
            if (decompressed === null) {
                return localStorage.getItem(key);
            }
            try {
                return JSON.parse(decompressed);
            } catch {
                return decompressed;
            }
        } catch (error) {
            console.error('Decompression error for key:', key, error);
            return localStorage.getItem(key);
        }
    },
    getCustomerEntityName() {
        let customerEntityName;
        const clientSettings = localStorage.clientSettings ? JSON.parse(localStorage.clientSettings) : {};

        if (clientSettings.CustomerEntityName && clientSettings.CustomerEntityName.trim() !== "") {
            customerEntityName = clientSettings.CustomerEntityName;
        } else {
            customerEntityName = constant.CUSTOMER_ENTITY_NAME;
        }
        return customerEntityName;
    },
    getPepAndSanctionMapValue(keyprm) {
        //filtre değerine sahip en az bir key olması beklenir.
        //keyperm  role.pep ise clientsetting'teki pepAndSanctionMappings'i kullanarak şu işlem yapılır:
        //role.pep keyinin değeri alınır: PEP  daha sonra aynı değere sahip diğer key'ler bulunarak joinlenir:
        //"role.pep,ROLE.PEP"

        const clientSettings = localStorage.clientSettings
            ? JSON.parse(localStorage.clientSettings)
            : {};

        const mappingsRaw = clientSettings.pepAndSanctionMappings;
        if (!mappingsRaw) {
            return keyprm;
        }

        const mappings = JSON.parse(mappingsRaw);

        const directValue = mappings[keyprm];
        if (!directValue) {
            return keyprm;
        }

        const matchingKeys = Object.keys(mappings).filter(
            (k) => mappings[k] === directValue
        );

        return matchingKeys.join(",");
    },
    formatCurrency(value) {
        if (value) {
            if (value.includes(",")) {
                value = parseFloat(value.replace(",", "."));
            } else {
                value = parseFloat(value);
            }
            return value.toLocaleString("tr-TR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        } else {
            return "";
        }
    },
    sanitizeHtml(html) {
        return DOMPurify.sanitize(html, {
            ALLOWED_TAGS: [
                "b",
                "i",
                "u",
                "strong",
                "em",
                "p",
                "br",
                "ul",
                "ol",
                "li",
                "span",
                "div",
                "code",
                "pre",
                "blockquote",
            ],
            ALLOWED_ATTR: ["style"],
            ALLOWED_CSS_PROPERTIES: ["color", "background-color", "font-weight", "text-decoration", "font-style"],
        });
    },
};
export default commonFunc;
